module.exports = __webpack_public_path__ + "media/images/gallery/constellations/monoceros/mon_vis-c963ee0921d311fe09f11543c241c46e.jpg";